import React from "react";
import { Info } from "lucide-react";
import MissingFieldsList from "./MissingFieldsList";
import { Schema } from "../../../configuration/common-models/CommonModelToggleTypes";
import { Text, Tooltip } from "@merge-api/merge-javascript-shared";

type CommonModelFieldMissingFieldCellProps = {
  commonModel: string;
  missingFields: string[];
  modelSchema: Schema;
  isLoading?: boolean;
};

const CommonModelMissingFieldCell = ({
  commonModel,
  missingFields,
  modelSchema,
  isLoading,
}: CommonModelFieldMissingFieldCellProps) => {
  return (
    <div className="px-1.5 rounded border border-gray-10 flex flex-row items-center gap-1">
      <Text variant="title-sm">{commonModel}</Text>
      <Tooltip
        title={
          <MissingFieldsList
            missingFields={missingFields}
            modelSchema={modelSchema}
            isLoading={isLoading}
          />
        }
        tooltipClassName="!max-w-[280px] w-[280px] !max-h-[218px]"
        variant="white"
      >
        <span className="flex items-center">
          <Info size={12} className="cursor-pointer" />
        </span>
      </Tooltip>
    </div>
  );
};
export default CommonModelMissingFieldCell;
